module.exports = __webpack_public_path__ + "img/md-assessment-c.2415c998.svg";